// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {PutCustomerError} from 'redux/v1/customer/put/actions';
import type {PutState} from 'redux/v1/customer/put/PutState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  PURE,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {putState} from 'redux/v1/customer/CustomerState';
import {PUT_CUSTOMER, SET_CUSTOMER_ERROR} from 'redux/v1/customer/put/actions';
import {parseErrors} from 'redux/v1/customer/put/utils';

export const initialState: PutState = {
  loading: false,
};

const actionCreators: ActionHandlers<PutState> = {
  [PENDING(PUT_CUSTOMER)]: (state: PutState) => ({
    ...state,
    loading: true,
    success: false,
    errors: null,
  }),
  [SUCCESS(PUT_CUSTOMER)]: (state: PutState) => ({
    ...state,
    loading: false,
    success: true,
    errors: {},
  }),
  [ERROR(PUT_CUSTOMER)]: (state: PutState, action: PutCustomerError) => ({
    ...state,
    success: false,
    loading: false,
    errors: parseErrors(action.error),
  }),
  [PURE(SET_CUSTOMER_ERROR)]: (state: PutState, action) => ({
    ...state,
    success: false,
    errors: action.errors,
  }),
};

export const putReducer: Reducer<PutState> = // $FlowIgnore
  createReducerUsingActionHandlers<PutState>(initialState, actionCreators);

export const getErrors: Selector<{[string]: string}> = createSelector(
  putState,
  (state: PutState) => (state.errors ? state.errors : {})
);
